import { useLocation } from 'react-router-dom';
import { useContext, useEffect } from 'react';
import { AuthContext } from 'src/context/AuthContext';
import mark from 'src/assets/branding/auto-appy-mark-256x256.png';
import 'src/stage/ai-stage.css';

function ProtectedRoute({ element }) {
  const { auth, loading, beginLogin, authError } = useContext(AuthContext);
  const location = useLocation();

  useEffect(() => {
    if (!loading && !auth && !authError) beginLogin(`${location.pathname}${location.search}`);
  }, [auth, authError, beginLogin, loading, location.pathname, location.search]);

  if (authError === 'access_denied') {
    return (
      <div className="ai-boot" role="alert">
        <img src={mark} alt="" />
        <strong>No access to Auto Appy AI</strong>
        <span>Your Auto Appy account does not have access to this application. Ask an organisation owner to turn on Auto Appy AI for you.</span>
      </div>
    );
  }
  if (loading || !auth) {
    return (
      <div className="ai-boot" role="status">
        <img src={mark} alt="" />
        <strong>Connecting to Auto Appy…</strong>
        <span className="ai-boot-bar" aria-hidden="true" />
      </div>
    );
  }
  return element;
}

export default ProtectedRoute;
